<div class="page-layout blank p-24" fusePerfectScrollbar>
  <app-reports></app-reports>
</div>
